<template>
  <div class="map-params">
    <h2>Paramétrage de la carte</h2>
    <br />
    <div id="map-param-color">
      <div class="d-flex">
        <div id="color-region">
          <div class="card shadow mb-4">
            <!-- Card Header - Dropdown -->
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 font-weight-bold text-primary">Personnalisation des régions</h6>
            </div>
            <!-- Card Body -->
            <table class="table table-responsive p-3">
              <tr>
                <td> Couleur des régions :</td>
                <td><input class="form-control-personalize" id="colorRegion" type="color" v-model="mapParams.region.color" /></td>
              </tr>
              <tr>
                <td>Couleur des bordures des régions :</td>
                <td><input class="form-control-personalize" id="colorBorderRegion" type="color" v-model="mapParams.region.fillcolor" /></td>
              </tr>
            </table>
          </div>
        </div>
        <div id="color-dept">
          <div class="card shadow mb-4">
            <!-- Card Header - Dropdown -->
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 font-weight-bold text-primary">Personnalisation des départements</h6>
            </div>
            <!-- Card Body -->
            <table class="table table-responsive p-3">
              <tr>
                <td>Couleur des départements :</td>
                <td><input class="form-control-personalize" id="colorDepartement" type="color" v-model="mapParams.departement.color" /></td>
              </tr>
              <tr>
                <td>Couleur des bordures des départements :</td>
                <td><input class="form-control-personalize" id="colorBorderDepartement" type="color" v-model="mapParams.departement.fillcolor" /></td>
              </tr>
            </table>
          </div>
        </div>
        <div id="color-dept-advs">
          <div class="card shadow mb-4">
            <!-- Card Header - Dropdown -->
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 font-weight-bold text-primary">Personnalisation des départements advs</h6>
            </div>
            <!-- Card Body -->
            <table class="table table-responsive p-3">
              <tr>
                <td>Couleur des départements advs :</td>
                <td><input class="form-control-personalize" id="colorDepartementAdvs" type="color" v-model="mapParams.departementAdvs.color" /></td>
              </tr>
              <tr>
                <td>Couleur des bordures des départements advs :</td>
                <td><input class="form-control-personalize" id="colorBorderDepartementAdvs" type="color" v-model="mapParams.departementAdvs.fillcolor" /></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <button type="button" class="btn-save" v-on:click="updateColorRegionAndDepartements()">Enregistrer</button>
      <div id="color-stats">
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">Personnalisation des statistiques</h6>
          </div>
          <!-- Card Body -->
          <table class="table table-responsive p-3">
            <tr>
              <td>Valeur du seuil inférieur: </td>
              <td><input class="form-control-personalize" type="number" min="0" max="100" v-model="mapParams.stats.statSeuil1" /></td>
            </tr>
            <tr>
              <td>Valeur du seuil intermediaire: </td>
              <td><input class="form-control-personalize" type="number" min="0" max="100" v-model="mapParams.stats.statSeuil2" /></td>
            </tr>
            <tr>
              <td>Valeur du seuil supérieur: </td>
              <td><input class="form-control-personalize" type="number" min="0" max="100" v-model="mapParams.stats.statSeuil3" /></td>
            </tr>
            <tr>
              <td>Couleur de la statistique inférieure :</td>
              <td><input class="form-control-personalize" id="colorStatInf" type="color" v-model="mapParams.stats.colorStat4" /></td>
            </tr>
            <tr>
              <td>Couleur des bordures de la statistique inférieure :</td>
              <td><input class="form-control-personalize" id="colorBorderStatInf" type="color" v-model="mapParams.stats.fillcolorStat4" /></td>
            </tr>
            <tr>
              <td>Couleur de la statistique intermédiaire basse :</td>
              <td><input class="form-control-personalize" id="colorStatEgal" type="color" v-model="mapParams.stats.colorStat3" /></td>
            </tr>
            <tr>
              <td>Couleur des bordures de la statistique intermédiaire basse :</td>
              <td><input class="form-control-personalize" id="colorBorderStatEgal" type="color" v-model="mapParams.stats.fillcolorStat3" /></td>
            </tr>
            <tr>
              <td>Couleur de la statistique intermédiaire haute :</td>
              <td><input class="form-control-personalize" id="colorStatEgal" type="color" v-model="mapParams.stats.colorStat2" /></td>
            </tr>
            <tr>
              <td>Couleur des bordures de la statistique intermédiaire haute :</td>
              <td><input class="form-control-personalize" id="colorBorderStatEgal" type="color" v-model="mapParams.stats.fillcolorStat2" /></td>
            </tr>
            <tr>
              <td>Couleur de la statistique supérieure :</td>
              <td><input class="form-control-personalize" id="colorStatSup" type="color" v-model="mapParams.stats.colorStat1" /></td>
            </tr>
            <tr>
              <td>Couleur des bordures de la statistique supérieure :</td>
              <td><input class="form-control-personalize" id="colorBorderStatSup" type="color" v-model="mapParams.stats.fillcolorStat1" /></td>
            </tr>
          </table>
        </div>
        <button type="button" class="btn-save" v-on:click="updateColorStats()">Enregistrer</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { apiPost } from "@/utils";
  import { initMapParams } from "@/utils/adminMapsMixin";

  export default {
    name: 'MapParams',
    data() {
      return {
        mapParams: {
          departement: {
            color: "",
            fillcolor: ""
          },
          region: {
            color: "",
            fillcolor: ""
          },
          departementAdvs: {
            color: "",
            fillcolor: ""
          },
          stats: {
            colorStat1: "",
            fillcolorStat1: "",
            colorStat2: "",
            fillcolorStat2: "",
            colorStat3: "",
            fillcolorStat3: "",
            colorStat4: "",
            fillcolorStat4: "",
            statSeuil1: 0,
            statSeuil2: 0,
            statSeuil3: 0,
          }
        },
        routes: []

      }
    },
    mounted() {
      this.initData();
    },
    methods: {
      initData() {
        initMapParams().then(res => {
          this.mapParams = res;
        });
      },
      updateColorRegionAndDepartements() {
        const p1 = apiPost("maps/maps-parameters/scope/update?scope=Region&innerColor=" + this.mapParams.region.fillcolor.replace("#", "%23") + "&color=" + this.mapParams.region.color.replace("#", "%23"))
        const p2 = apiPost("maps/maps-parameters/scope/update?scope=Departement&innerColor=" + this.mapParams.departement.fillcolor.replace("#", "%23") + "&color=" + this.mapParams.departement.color.replace("#", "%23"))
        const p3 = apiPost("maps/maps-parameters/scope/update?scope=DepartementAdvs&innerColor=" + this.mapParams.departementAdvs.fillcolor.replace("#", "%23") + "&color=" + this.mapParams.departementAdvs.color.replace("#", "%23"))

        Promise.all([p1, p2, p3])
          .then(e => {
            alert("Sauvegarde effectuée avec succés");
            this.initData();
            console.log(e);
          })
          .catch(e => {
            alert("Erreur de sauvegarde");
            console.log(e);
          });
      },

      updateColorStats() {
          const p1 = apiPost("maps/maps-parameters/scope/update?scope=ColorStat1&innerColor=" + this.mapParams.stats.fillcolorStat1.replace("#", "%23") + "&color=" + this.mapParams.stats.colorStat1.replace("#", "%23"))
          const p2 = apiPost("maps/maps-parameters/scope/update?scope=ColorStat2&innerColor=" + this.mapParams.stats.fillcolorStat2.replace("#", "%23") + "&color=" + this.mapParams.stats.colorStat2.replace("#", "%23"))
          const p3 = apiPost("maps/maps-parameters/scope/update?scope=ColorStat3&innerColor=" + this.mapParams.stats.fillcolorStat3.replace("#", "%23") + "&color=" + this.mapParams.stats.colorStat3.replace("#", "%23"))
          const p4 = apiPost("maps/maps-parameters/scope/update?scope=ColorStat4&innerColor=" + this.mapParams.stats.fillcolorStat4.replace("#", "%23") + "&color=" + this.mapParams.stats.colorStat4.replace("#", "%23"))
          const p5 = apiPost("maps/maps-parameters/scope/update?scope=pdmSeuil1&innerColor=" + this.mapParams.stats.statSeuil1 + "&color=" + this.mapParams.stats.statSeuil1)
          const p6 = apiPost("maps/maps-parameters/scope/update?scope=pdmSeuil2&innerColor=" + this.mapParams.stats.statSeuil2 + "&color=" + this.mapParams.stats.statSeuil2)
          const p7 = apiPost("maps/maps-parameters/scope/update?scope=pdmSeuil3&innerColor=" + this.mapParams.stats.statSeuil3 + "&color=" + this.mapParams.stats.statSeuil3)

        Promise.all([p1, p2, p3, p4, p5, p6, p7])
          .then(e => {
            alert("Sauvegarde effectuée avec succés");
            this.initData();
            console.log(e);
          })
          .catch(e => {
            alert("Erreur de sauvegarde");
            console.log(e);
          });
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #color-region,
  #color-dept {
    margin-right: 3%;
  }

  #color-stats {
    margin-top: 2%;
    width: auto;
    max-width: 29%;
  }

  #color-region,
  #color-dept,
  #color-dept-advs {
    display: inline-block;
  }

  input.form-control-personalize {
    display: block;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Admin/AdminMaps/MapsParameters.vue